import { render } from "./InterfaceTab.vue?vue&type=template&id=e777e1fa&scoped=true"
import script from "./InterfaceTab.vue?vue&type=script&lang=js"
export * from "./InterfaceTab.vue?vue&type=script&lang=js"

import "./InterfaceTab.vue?vue&type=style&index=0&id=e777e1fa&scoped=true&lang=scss"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e777e1fa"]])

export default __exports__